import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserConfiguration } from '@app/auth/services/custom-authentication.service';
import { CustomSpinnerRequestHeader } from '@app/custom-service/spinner-interceptor.service';
import { AppAutoCompleteModel } from '@app/custom-shared/components/form/app-auto-complete/app-auto-complete.component';
import { DashboardService } from '@app/features/dashboard/shared/services/dashboard.service';
import { environment } from 'src/environments/environment';
const BASE_PATH = environment.basePath;
@Injectable({
    providedIn: 'root'
})
export class UserConfigService {

    constructor(private dashService: DashboardService, private httpClient: HttpClient) { }

    basic: UserConfiguration;
    dashboard: DashboardConfig = new DashboardConfig(this.dashService);

    get isCaceis() {
        if (this.basic && this.basic.isCaceis && this.basic.isCaceis == true) {
            return true;
        }
        return false;
    }
}

class DashboardConfig {

    constructor(dashService: DashboardService) {
        this.dashService = dashService;
    }

    dashService: DashboardService

    defaultClient: AppAutoCompleteModel = { label: "", value: "" };
    cotasClientSelected: AppAutoCompleteModel = this.defaultClient;
    fundosClientSelected: AppAutoCompleteModel = this.defaultClient;
    cotasDetailsClientSelected: AppAutoCompleteModel = this.defaultClient;
    fundosDetailsClientSelected: AppAutoCompleteModel = this.defaultClient;
    operationClientSelected: AppAutoCompleteModel = this.defaultClient;

    clientList: AppAutoCompleteModel[] = [];

    cotasSelectedDate: Date = new Date();
    private defaultDate: Date;

    setSelectedDateAndGetDateString(date?: Date): string {
        if (date) this.cotasSelectedDate = date;
        return this.getSelectedDateAsString();
    }

    setCotasDefaultDate(date?: Date) {
        if (!this.defaultDate) {
            this.defaultDate = date;
            this.setSelectedDateAndGetDateString(this.defaultDate);
        }
    }

    getSelectedDateAsString(): string {
        return this.toIsoString(this.cotasSelectedDate).slice(0, 10);
    }

    // async updateClientList() {
    //     let clientResponse: AppAutoCompleteModel[] = await this.dashService.getClients().toPromise();
    //     this.clientList = clientResponse;
    // }

    toIsoString(date) {
        var tzo = -date.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function (num) {
                var norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate())
    }
}
